import React, { useRef, useContext, useEffect } from 'react'
import styleSheet from './videoAuto.m.scss'
import VideoPlayerContext from '../videoPlayerContext'
import ReactPlayer from 'react-player'

const isMobile = window.innerWidth < 768

export const VideoAuto = ({ src }: { src: string }) => {
  const videoRef = useRef(null)
  const { muted, setMuted } = useContext(VideoPlayerContext)
  const previousSrc = useRef(src)

  const handleMuteIconClick = () => {
    setMuted(!muted)
  }

  useEffect(() => {
    if (isMobile) {
      setMuted(true)
    }

    // if (previousSrc.current === src) {
    //   return
    // }

    // if (videoRef.current) {
    //   videoRef.current.load()
    // }

    // previousSrc.current = src
  }, [src])

  return (
    <div className={styleSheet.videoAutoContainer}>
      <ReactPlayer
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload noplaybackrate pictureinpicture'
            }
          }
        }}
        playsinline
        playing
        loop
        controls
        muted={muted}
        url={src}
      />

      {/* <video
        ref={videoRef}
        onClick={handleMuteIconClick}
        className={styleSheet.video}
        autoPlay
        loop
        playsInline
        muted={muted}
      >
        <source src={src} type='video/mp4' />
        Votre navigateur n'est pas en mesure d'afficher les vidéos.
      </video> */}
      {muted && (
        <div onClick={handleMuteIconClick} className={styleSheet.soundIcon}>
          {muted ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='24'
              viewBox='0 0 20 24'
            >
              <path
                d='M19,7.36V23l-8-5v-.78Zm3-6.1L20.45,0,17,4.25,11,8v3.65L9,14.11V8H5V18h.84L2,22.74,3.55,24Z'
                transform='translate(-2 0)'
              />
            </svg>
          ) : (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='28'
              viewBox='0 0 24 24'
            >
              <path
                d='M6,7l8-5v20l-8-5V7z M0,17h4V7H0V17z M20.3,3.7l-1.5,1.5c1.8,1.8,3,4.2,3,6.8s-1.1,5-3,6.8l1.5,1.5c2.3-2.2,3.7-5.1,3.7-8.3
	S22.6,5.9,20.3,3.7z M19.8,12c0-2.1-0.9-4-2.4-5.4l-1.5,1.5c1,1,1.6,2.4,1.6,3.9c0,1.5-0.6,2.8-1.6,3.9l1.5,1.5
	C18.9,16,19.8,14.1,19.8,12z'
              />
            </svg>
          )}
          <div className={styleSheet.soundIconLabel}>
            <div className={styleSheet.soundIconLabelContent}>
              {muted ? 'Réactiver' : 'Couper'} le son
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
